import React, { useEffect, useRef, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import {
  getAllEmailAsync,
  EmailManagementActions,
  getAllEmailTemplatesAsync,
} from "../redux";
import EmailManagementTable from "./email_management_detail/emailManagementTable";
import {
  Card,
  CardHeader,
  CardHeaderToolbar,
} from "./../../../../_metronic/_partials/controls";
import AddTemplate from "./AddTemplate";
import EditTemplate from "./EditTemplate";


export function EmailManagement() {
  const [showAddTemplate, setShowAddTemplate] = useState(false);
  const [showEditTemplete, setShowEditTemplate] = useState(false);
  const dispatch = useDispatch();
  const searchEmailRef = useRef();
  const history = useHistory();
  const type = "EMAIL";
  const { refreshEmailList, searchBy, searchText } = useSelector(
    (state) => state.emailManagement,
    shallowEqual
  );
  //call api while search
  useEffect(() => {

    if (searchEmailRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(EmailManagementActions.refreshEmailList());
        }
      };
      let input = searchEmailRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(EmailManagementActions.searchTextChange(""));
        input.value = "";
      };
    }
  }, []);
  useEffect(() => {
    if (refreshEmailList) {
      dispatch(getAllEmailAsync(searchBy, searchText, type));//call api for get email list
    }
  }, [refreshEmailList]);

  // useEffect(() => {
  //   dispatch(getAllEmailTemplatesAsync());
  // }, []);

  const onAddClick = () => {
    setShowAddTemplate(true);
  };
  //save edit email details
  const onEditClick = (email) => {
    dispatch(EmailManagementActions.setSelectedEmail(email));
    setShowEditTemplate(true);
  };
  //save search text
  const onSearchTextChange = (e) => {
    dispatch(EmailManagementActions.searchTextChange(e.target.value));
  };


  return (
    <>
      <Card>
        <CardHeader title="Email Management">
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
              <form autoComplete="off"
                className="subheader_filter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-row">
                  <div className="form-group mr-5 mb-1 mt-2">
                    <button
                      className="btn_new btn-sm"
                      type="button"
                      onClick={() => onAddClick()}
                    >
                      Add
                    </button>
                  </div>
                  <div className="form-group mr-3 mb-1">
                    <input
                      name="Search"
                      placeholder="Search. . ."
                      type="text"
                      className="form-control"
                      value={searchText}
                      onChange={onSearchTextChange}
                      ref={searchEmailRef}
                    />
                  </div>
                </div>
              </form>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <EmailManagementTable onEditClick={onEditClick} />
        <AddTemplate setShowAddTemplate={setShowAddTemplate} showAddTemplate={showAddTemplate} />
        <EditTemplate showEditTemplete={showEditTemplete} setShowEditTemplate={setShowEditTemplate} />
      </Card>
    </>
  );
}
